import { createFileRoute } from "@tanstack/react-router";
import { MessageCircleWarning } from "lucide-react";

export const Route = createFileRoute("/help/tutorials/public_audit")({
    component: PublicAuditTutorialPage,
});


export default function PublicAuditTutorialPage() {
    return (
        <div>
            {/* 主要内容 */}
            <div className="px-4 py-6">
                {/* 标题部分 */}
                <div className="mb-8">
                    <h1 className="text-2xl font-bold text-gray-900 mb-3">
                        欢迎来到公审系统
                    </h1>
                    <div className="flex items-center justify-between">
                        <p className="text-sm text-gray-700 leading-relaxed">
                            使用本系统之前，请您先阅读下面的内容，以便更好的使用公审系统。
                        </p>
                        {/* <button className="text-orange-500 text-sm flex items-center hover:text-orange-600 transition-colors">
                            进一步了解
                            <ChevronRight className="w-4 h-4 ml-1" />
                        </button> */}
                    </div>
                </div>

                {/* 规则内容 */}
                <div className="space-y-6">
                    {/* 规则1 */}
                    <div className="bg-gray-50 rounded-lg p-4">
                        <h3 className="text-lg font-semibold text-gray-900 mb-3">
                            1、确保您的决定公正、公平
                        </h3>
                        <p className="text-sm text-gray-700 leading-relaxed mb-2">
                            拥有公审权限意味着系统认为您具备一定的绘画技能水平，对参与审核的用户具有一定的判断能力。
                            因此，请您在审核过程中保持公正、公平的态度。避免带有个人偏见的审核结果。
                        </p>
                        <p className="text-sm text-gray-700 leading-relaxed mb-3">
                            每个人的绘画技能水平不同，请尊重每一位参审画师。
                            建议从多个维度评估申请人，例如：
                        </p>
                        <p className="text-sm text-gray-700">
                            五官是否正确、上色是否合理、是否有较高的完成度等等，如果您认为您无法做出准确的判断，您可以选择“跳过该作品”来避免误判。
                        </p>
                        <p className="text-sm text-red-600 font-medium mt-3">
                            包庇、贿赂或后门等行为是不被允许的。
                        </p>
                    </div>

                    {/* 规则2 */}
                    <div className="bg-gray-50 rounded-lg p-4">
                        <h3 className="text-lg font-semibold text-gray-900 mb-3">
                            2、请保护申请人的隐私
                        </h3>
                        <p className="text-sm text-gray-700 leading-relaxed mb-3">
                            画师可能会提交未公开或商业作品进行审核。在审核过程中，请您始终假设这些作品为
                            <span className="font-medium">非公开作品</span>。
                        </p>
                        <div className="space-y-2">
                            <p className="text-sm text-gray-700">
                                请勿出现下面的行为：
                            </p>
                            <ol className="list-decimal list-inside space-y-1 text-sm text-gray-700 ml-4">
                                <li>将公审内容通过任何方式发布到社交或公开的空间中。</li>
                                <li>在公共环境讨论参审画师的作品。</li>
                                <li>通过作品联系参审画师或通过任何途径对他人进行骚扰。</li>
                            </ol>
                        </div>
                    </div>

                    {/* 规则3 */}
                    <div className="bg-gray-50 rounded-lg p-4">
                        <h3 className="text-lg font-semibold text-gray-900 mb-3">
                            3、您是平台环境的守护者
                        </h3>
                        <p className="text-sm text-gray-700 leading-relaxed mb-3">
                            平台的使命是给委托人一个安全的交易环境，您的每一次审核十分重要，因此：
                        </p>
                        <p className="text-sm text-red-600 font-medium mb-3">
                            对盗图、描图、使用他人作品或 AIGC内容请直接拒绝。
                        </p>
                        <p className="text-sm text-gray-700">
                            如发现有可疑或严重破坏市场环境的行为，请使用"举报"按钮提交举报，客服将及时核实处理。
                        </p>
                    </div>
                </div>

                {/* 特别提醒 */}
                <div className="mt-8 p-4 bg-orange-50 border border-orange-200 rounded-lg">
                    <div className="flex items-center gap-2 mb-1">
                        <MessageCircleWarning className="w-6 h-6 text-orange-700" />
                        <h4 className="text-lg font-semibold text-orange-700">
                            特别提醒
                        </h4>
                    </div>
                    <p className="text-sm text-orange-800 leading-relaxed">
                        在每个画师公审结束后，系统将根据审核结果对您的判断能力进行综合评分。
                        如果您的评分过低，您的公审权限可能会被暂时撤销。
                    </p>
                </div>
            </div>
        </div>
    );
}
